import React from 'react';
import './styles.scss';


class HiresCardTwo extends React.Component {
  render() {

    const { icon, title, text } = this.props

    return (
      <div className="hires__card2__container">
        <div className="plus__button"></div>
        <div className="hires__card__content">
          <h4 className="hires__card__title">{title}</h4>
          <img class="hires__card__image" src={icon} alt="MBPS" />
          <h5 className="hires__card__text">{text}</h5>
          <button className="hires__card__button">lo quiero</button>
        </div>
      </div>
    )
  }
}


export default HiresCardTwo;
